<div class="cw">
  <div class="cw__field">
    <input [id]="inputId" class="sd-input cw__input" type="url" name="website" autocomplete="off" inputmode="url"
           [(ngModel)]="website" [readonly]="!editable || busy" [disabled]="!loaded"
           [placeholder]="editable ? 'www.example.com' : 'No website'"
           (change)="save()" (keydown.enter)="save()">
    <a class="cw__open" *ngIf="href && !busy" [href]="href" target="_blank" rel="noopener noreferrer"
       title="Open the website" aria-label="Open the website">
      <svg viewBox="0 0 12 12" fill="none" aria-hidden="true">
        <path d="M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7 2h3v3M10 2L5.5 6.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
  </div>
  <!-- A failed save, or why a saved website brought no logo; a website that matches brings its logo
       with it, without saying so. -->
  <span class="cw__status" *ngIf="status" [attr.data-tone]="status.tone">{{ status.text }}</span>
</div>
